import { getVocabProgressRatio } from 'a/hub/selectors';
import { useFirstUserInteraction } from 'lib/hooks';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearSessionProgress } from 'a/hub/actions/studentProgressActions';
import { DescriptionText, EarlyExitPanel, HeaderText, RadioIcon } from '../sharedComponents';

const VocabEarlyExitModal = ({ closeModal, config }) => {
  const completeRatio = useSelector(getVocabProgressRatio);

  const dispatch = useDispatch();

  const {
    heading = 'Transmission Not Secured',
    text = 'Good work, but you need to complete more activities to receive a transmission.',
  } = config;

  const firstUserInteraction = useFirstUserInteraction();

  const onClick = (e) => {
    dispatch(clearSessionProgress());
    firstUserInteraction(e);
    closeModal(e);
  };

  return (
    <EarlyExitPanel onConfirm={onClick} actionScope="vocab-early-exit-modal">
      <StyledHeaderText>{heading}</StyledHeaderText>
      <DescriptionText top={288} left={486}>
        {text}
      </DescriptionText>
      <RadioIcon top={200} left={345} completeRatio={completeRatio} />
    </EarlyExitPanel>
  );
};

VocabEarlyExitModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default VocabEarlyExitModal;

const StyledHeaderText = styled(HeaderText)`
  position: absolute;
  top: 219px;
  left: 486px;
  width: 248px;
  height: 32px;
`;
